import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {StyleLine} from './StyleLine';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class Style extends BasicEntity {
code: string;
description: TranslatedEmb;
lines: {[key: string]: StyleLine};
owner: string;
visionCode: string;
}

